var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-input',{attrs:{"placeholder":_vm.placeholder,"btn-class":_vm.btnClass,"input-class":_vm.inputClass,"value":_vm.selected},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }